import $ from 'domtastic'
import gsap from 'gsap'

import { clamp, BB, CS } from '../utils/utils'

import Menu from './blocks/ui/Menu'


const compsMap = {
    Menu,
}




/* LAYOUT
----------------------------------------------------------------------------------------------------*/

export default class Layout {

    constructor() {
        this.$els = {
            window      : $(window),
            doc         : $(document),
            html        : $('html'),
            body        : $('body'),
            scroller    : $('.scroller'),
            header      : $('#header'),
            headerW     : $('.header__wrapper'),

            gridCtn  : $('#grid-ctn'),
            grid     : $('#grid'),
            colSizer : $('.gridSizer.col-1'),
            gutSizer : $('.gridSizer.gut-1'),
            vphSizer : $('.gridSizer.vph'),
        }


        this.comps = {}


        this.varsReady       = false
        this.dragging        = false
        this.scrollBlocked   = false
        this.scrollTop       = window.pageYOffset
        this.scrollTimer     = null
        this.resizeTimer     = null
        this.activeEvent     = APP.Browser.supports.passive ? { passive: false } : false
        this.isScrollingDown = true

        this.getLayoutValues(true)
        this.getDocValues()

        this.resizeHandler     = () => { this.onResize() }
        this.layoutTypeHandler = (e) => { this.onLayoutTypeChange(e) }
        this.scrollHandler     = () => { this.onScroll() }
        this.touchmoveHandler  = (e) => { this.onTouchMove(e) }
        this.wheelHandler      = (e) => { this.onWheel(e) }


        this.bindEvents()
        setTimeout(() => this.initComps(), 0)
    }


    bindEvents() {
        const { doc: $doc, window: $window, body: $body } = this.$els

        // Size events
        $doc.on('layoutTypeChange', this.layoutTypeHandler)

        // Window events
        $window.on('scroll', this.scrollHandler)
        $window.on('resize', this.resizeHandler)

        // Input events
        document.addEventListener('touchmove', this.touchmoveHandler, this.activeEvent)
        document.addEventListener('wheel', this.wheelHandler, this.activeEvent)

        // Components events
        $doc.on('menuToggled', (e) => { this.onMenuToggled(e) })
        $doc.on('overlayToggled', ({ detail }) => { this.onOverlayToggled(detail) })

        // a11y
        $('.js-skipLink').on('click', (e) => { focusAnchor(e) })
        $body.on('mousedown', () => { this.toggleKeyboardNav(false) })
        $body.on('keydown', (e) => { this.onKeyDown(e) })


        // Toggle Grid (dev purposes only)
        if ($('#gridWrapper').length) {
            this.initVisualGrid()
        }
    }


    initComps() {
        $('[data-layout-component]').forEach((el) => {
            const $el = $(el)

            const compName = $el.attr('data-layout-component').replace(/-|\s/g, '')
            const compsList = compName.split(',')

            $el.removeAttr('data-layout-component')

            compsList.forEach((c) => {
                if (compsMap[c]) {
                    if (!this.comps[c]) {
                        this.comps[c] = new compsMap[c]($el, this.namespace, this)
                    }
                } else {
                    console.warn(`Layout Component [${c}] not registered in Layout.`)
                }
            })
        })
    }


    initVisualGrid() {
        this.$els.doc.on('keydown', (e) => {
            const tag = document.activeElement.tagName.toLowerCase()

            if (e.key === 'g' && tag !== 'input' && tag !== 'textarea' && tag !== 'select') {
                e.preventDefault()
                this.$els.body.toggleClass('grid-visible')
            }
        })

        document.addEventListener('touchmove', (e) => {
            if (e.touches.length > 2) {
                e.preventDefault()

                if (!this.isGridDragging) {
                    this.isGridDragging = true
                    this.$els.body.toggleClass('grid-visible')
                }
            }
        }, this.activeEvent)

        this.$els.doc.on('touchend', () => { this.isGridDragging = false })
    }




    /* Handlers
    ---------------------------------------------------------*/

    onResize(force) {
        const { doc: $doc, body: $body } = this.$els


        this.resizing = true
        this.getLayoutValues()
        this.getDocValues()


        // Resize timer
        clearTimeout(this.resizeTimer)
        $body.addClass('resizing')

        this.resizeTimer = setTimeout(() => {
            this.resizing = false

            $body.removeClass('resizing')

            if (!this.falseResize && !force) {
                $doc.trigger('layoutChange')
            }
        }, 150)
    }


    onLayoutTypeChange({ detail }) {
        //
    }


    onScroll() {
        const prevScroll = this.scrollTop
        this.scrollTop   = window.pageYOffset

        this.wasScrollingDown = this.isScrollingDown
        this.isScrollingDown  = this.scrollTop - prevScroll > 0 || window.scrollY <= 0
    }


    onTouchMove(e) {
        if (this.scrollBlocked) e.preventDefault()
    }


    onWheel(e) {
        if (this.scrollBlocked) e.preventDefault()
    }


    onMenuToggled({ detail }) {
        this.isMenuOpen    = detail.isOpen
        this.scrollBlocked = detail.isOpen

        this.toggleWheelEvent()
    }


    onOverlayToggled({ isOpen, trigger = 'overlay' }) {
        this.scrollBlocked = isOpen
        this.hasOpenOverlay = isOpen

        this.$els.body.toggleClass(`${trigger}-open`, isOpen)

        this.toggleWheelEvent()
    }


    onKeyDown({ key }) {
        if (['Tab', 'ArrowUp', 'ArrowDown'].includes(key)) {
            this.toggleKeyboardNav(true)
        }
    }




    /* Actions
    ---------------------------------------------------------*/

    toggleKeyboardNav(shouldActivate = !this.isUsingKeyboard) {
        if (shouldActivate === this.isUsingKeyboard) return
        this.isUsingKeyboard = shouldActivate

        this.$els.body.toggleClass('is-usingKeyboard', this.isUsingKeyboard)
        this.$els.body.toggleClass('is-usingMouse', !this.isUsingKeyboard)
    }


    toggleWheelEvent() {
        if (this.scrollBlocked) {
            document.addEventListener('touchmove', this.touchmoveHandler, APP.Browser.activeEvent)
            document.addEventListener('wheel', this.wheelHandler, APP.Browser.activeEvent)
        } else {
            document.removeEventListener('wheel', this.wheelHandler)
            document.removeEventListener('touchmove', this.touchmoveHandler)
        }
    }




    /* Values
    ---------------------------------------------------------*/

    getDocValues() {
        this.docHeight = document.body.clientHeight
        this.pixelDensity = clamp(window.devicePixelRatio, 1, 1.5)
    }


    getLayoutValues(isFirstTime) {
        const { doc: $doc, html: $html, gridCtn: $gridCtn } = this.$els

        if (this.W) this.prevW = this.W

        this.W = document.body.clientWidth
        this.H = window.innerHeight
        this.D = Math.hypot(this.W, this.H)
        this.maxH = this.$els.vphSizer[0].offsetHeight
        this.maxD = Math.hypot(this.W, this.maxH)

        this.scrollbarW   = window.innerWidth - this.W
        this.widthChanged = this.prevW !== this.W
        this.falseResize  = ((APP.Browser.isMobile || APP.Browser.isiOS) && !this.widthChanged)

        if (!this.baseH || !this.falseResize) {
            this.baseH = this.H
        }

        this.vpH = (APP.Browser.isMobile) ? this.baseH : this.H
        this.vpH = (APP.Browser.isAndroid) ? this.maxH : this.vpH


        // MQ
        const desktopMQ = window.matchMedia('(min-width: 961px)')
        this.isDesktop  = desktopMQ.matches
        this.isLDesktop = window.matchMedia('(min-width: 1112px)').matches
        this.isSDesktop = window.matchMedia('(min-width: 961px) and (max-width: 1280px)').matches
        this.isTablet   = window.matchMedia('(max-width: 960px) and (min-width: 744px)').matches
        this.isMobile   = window.matchMedia('(max-width: 743px)').matches

        if (isFirstTime) {
            desktopMQ.addListener((e) => {
                $doc.trigger('layoutTypeChange', e)
            })
        }


        // Elements sizes
        this.headerH = this.$els.headerW[0]?.offsetHeight ?? 0

        this.gridWidth = BB(this.$els.grid[0]).width
        this.colWidth  = BB(this.$els.colSizer[0]).width
        this.gutWidth  = BB(this.$els.gutSizer[0]).width
        this.margin    = parseFloat(CS($gridCtn[0], 'padding-left')) + parseFloat(CS($gridCtn[0], 'margin-left'))


        // CSS Custom Props
        gsap.set($html, {
            '--vh'   : `${this.vpH / 100}px`,
            '--vw'   : `${this.W / 100}px`,
            '--vmin' : `${Math.min(this.W / 100, this.vpH / 100)}px`,
            '--vmax' : `${Math.max(this.W / 100, this.vpH / 100)}px`,

            '--vpW'    : `${this.W}px`,
            '--vpH'    : `${this.vpH}px`,
            '--vpD'    : `${Math.ceil(this.D)}px`,
            '--sbW'    : `${this.scrollbarW}px`,

            '--col'    : `${this.colWidth}px`,
            '--gut'    : `${this.gutWidth}px`,
            '--margin' : `${this.margin}px`,
        })


        $doc.trigger('layoutVariablesChange')

        if (!this.varsReady) {
            this.varsReady = true

            setTimeout(() => {
                $html.addClass('variables')
            }, 100)
        }
    }

}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */


const focusAnchor = (e) => {
    e.preventDefault()

    const anchor = e.target.getAttribute('href')
    document.querySelector(anchor).focus()
}


